<div style="border: 1px solid #ddd; border-radius: 5px; padding: 1em; background-color: white;">
    <label>Expected output files</label>

    <dx-data-grid biz-grid
        [dataSource]='expectedOutputTestFiles'
        [selection]='{ mode: "single"}'
        [bizSetColumnChooser]='false'
        [bizSetAllowColumnReordering]='false'
        [bizHideSelectedRowsComponent]='true'
        [showResetButton]='false'
        [showRefreshButton]='false'
        [bizSetGroupPanel]='false'
        [bizSetPager]="false"
        [bizSetSearchPanel]="false"
        [loadPanel]='{ enabled: true }'
        [showBorders]="true"
        (onInitNewRow)="onInitNewRow($event)"
        (onRowInserting)="onRowInserting($event)"
        (onRowUpdating)="onRowUpdating($event)"
        (onEditCanceled)="onEditCanceled($event)"
        (onRowRemoving)="onRowRemoving($event)">

        <dxo-row-dragging [allowReordering]="true" [onReorder]="onReorder"></dxo-row-dragging>
        <dxo-sorting mode="none"></dxo-sorting>
        <dxo-scrolling mode="virtual"></dxo-scrolling>
        <dxo-column-fixing [enabled]="true"></dxo-column-fixing>
        <dxo-editing mode="popup" [allowUpdating]="allowUpdating" [allowAdding]="allowAdding" [allowDeleting]="allowDeleting">
            <dxo-form>
                <dxi-item dataField="File.Filename"></dxi-item>
                <dxi-item dataField="File.ContentTypeId"></dxi-item>
                <dxi-item dataField="File.EncodingId"></dxi-item>
                <dxi-item dataField="File.Note"></dxi-item>
            </dxo-form>
            <dxo-texts confirmDeleteMessage="Are you sure you want to delete this expected output file?"></dxo-texts>
        </dxo-editing>

        <ng-container>
            <dxi-column dataField="SortOrder" caption="Compare Order" dataType="number" [visible]="true"></dxi-column>
            <dxi-column dataField="File.Filename" caption="Filename" dataType="string" editCellTemplate="fileEditTemplate" [visible]="true">
                <dxi-validation-rule type="required"></dxi-validation-rule>
            </dxi-column>
            
            <dxi-column dataField="File.ContentTypeId" dataType="string" caption="Content Type" [visible]="true">
                <dxo-lookup [dataSource]="contentTypes" valueExpr="Id" displayExpr="Name" [allowClearing]="true"></dxo-lookup>
            </dxi-column> 

            <dxi-column dataField="File.EncodingId" caption="Encoding" dataType="string" editCellTemplate="encodingEditTemplate" [visible]="true">
                <dxo-lookup [dataSource]="encodings" valueExpr="EncodingId" [displayExpr]="encodingDisplayExpr"></dxo-lookup>
                <dxi-validation-rule type="required"></dxi-validation-rule>
            </dxi-column>

            <dxi-column dataField="File.Note" caption="Note" dataType="string" [visible]="true"></dxi-column>
            <dxi-column biz-grid-user dataField="CreatedBy" caption="Created By" [visible]="true">
                <dxo-header-filter [dataSource]="bizGridFiltervalues.getUserFilterData(bizGridFiltervalues.getPropertyValues(expectedOutputTestFiles, 'CreatedBy'))"></dxo-header-filter>
            </dxi-column>
            <dxi-column biz-grid-date dataField="CreatedDate" caption="Created Date" [visible]="true" format="dateTime"></dxi-column>
            <dxi-column biz-grid-user dataField="UpdatedBy" caption="Modified By" [visible]="true">
                <dxo-header-filter [dataSource]="bizGridFiltervalues.getUserFilterData(bizGridFiltervalues.getPropertyValues(expectedOutputTestFiles, 'UpdatedBy'))"></dxo-header-filter>
            </dxi-column>
            <dxi-column biz-grid-date dataField="UpdatedDate" caption="Modified Date" [visible]="true" format="dateTime"></dxi-column>
        </ng-container>

        <ng-container *dxTemplate="let cellInfo of 'fileEditTemplate'">
            <span [hidden]="!cellInfo.data.File.Filename">Current file: {{ cellInfo.data.File.Filename }}</span>
            <ep-file-uploader (fileOnValueChangedEvent)="fileOnValueChangedCallback($event, cellInfo)"
                                (fileOnBeforeSendEvent)="fileOnBeforeSendCallback($event, cellInfo)"
                                (fileOnUploadedEvent)="fileOnUploadedCallback($event, cellInfo)">
            </ep-file-uploader>
        </ng-container>

        <ng-container *dxTemplate="let cellInfo of 'encodingEditTemplate'">
            <app-encoding-picker (selectedEncodingIdChange)="setEncodingId($event, cellInfo)" [selectedEncodingId]="$safeNavigationMigration(cellInfo.data.File?.EncodingId)"></app-encoding-picker>
        </ng-container>
    </dx-data-grid> 

</div>
